module.exports = __webpack_public_path__ + "static/media/car-crash.a6c7cd72.svg";